module.exports = __webpack_public_path__ + "img/logo-horizontal.7a45fdac.png";